import { inject, Injectable } from '@angular/core';
import { type UpdateDashboardInput } from '@reconcept-platform/shared/types';
import { DashboardApi } from '../../api/dashboard/dashboard.api';
import { sortWorkspacesAlphabeticallyAndReCOCFirstAndCOCSecond } from '../../utils/utils';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private dashboardApi = inject(DashboardApi);

  updateDashboard(updateDashboardInput: UpdateDashboardInput) {
    return this.dashboardApi.updateDashboard(updateDashboardInput);
  }

  watchDashboardWithRoles(dashboardId: string) {
    return this.dashboardApi.watchDashboardWithRoles(dashboardId);
  }

  watchDashboardScopeForRoleModal(dashboardId: string) {
    return this.dashboardApi.watchDashboardScopeForRoleModal(dashboardId);
  }

  watchAllDashboards() {
    return this.dashboardApi.watchAllDashboardsWithWorkspaces();
  }

  watchDashboardWithWorkspaces(dashboardId: string) {
    return this.dashboardApi.watchDashboardWithWorkspaces(dashboardId);
  }

  watchDashboardWithWorkspacesAndCardCount(dashboardId: string) {
    return this.dashboardApi.watchDashboardWithWorkspacesAndCardCount(dashboardId);
  }

  watchDashboardMatrix(dashboardId: string) {
    return this.dashboardApi.watchDashboardMatrix(
      dashboardId,
      { dashboardIds: [dashboardId] },
      { secondaryDashboardIds: [dashboardId] },
    );
  }

  sortWorkspacesAlphabeticallyAndReCOCFirstAndCOCSecond<T extends { title?: string }>(workspaces: T[]): T[] {
    return sortWorkspacesAlphabeticallyAndReCOCFirstAndCOCSecond(workspaces);
  }
}
